import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/user',
        name: 'user',
		subheader: languages.user.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "04",
            icon: "user",
        },
        component: PageAll,
		children: [
			{
				path: '/user',
				name: 'user',
				component: resolve => require(['@/pages/user/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.user.title1,
					permCode: "0401",
				},
			}
		]
    }
]
  